<template>
    <FormControl
        :label="customField.title"
        :required="customField.isRequired"
        :error="
            errors.getValidationErrorUsingRawString(`${customField.id.value}`)
        "
    >
        <template
            v-if="
                typeof savedValue.response === 'string' ||
                savedValue.response === null
            "
        >
            <input
                type="hidden"
                :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CUSTOM_FIELD_ID_KEY}]`"
                :value="customField.id.value"
            />
            <template
                v-if="
                    localSettings.data.radioSelectType ===
                    CustomFieldRadioSelectTypeEnum.Select
                "
            >
                <SelectInput
                    :required="customField.isRequired"
                    :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CONTENT_KEY}]`"
                    :modelValue="savedValue.response"
                    :useBookingFormThemeCssVariables="true"
                >
                    <option
                        v-for="(option, index) in localSettings.data
                            .radioSelectOptions"
                        :key="index"
                        :value="option"
                    >
                        {{ option }}
                    </option>
                </SelectInput>
            </template>
            <template
                v-if="
                    localSettings.data.radioSelectType ===
                    CustomFieldRadioSelectTypeEnum.Radio
                "
            >
                <div class="space-y-2">
                    <RadioInput
                        v-for="(option, index) in localSettings.data
                            .radioSelectOptions"
                        :key="index"
                        :label="option"
                        :value="option"
                        :required="customField.isRequired"
                        :name="`${RequestBodyKeyEnum.ScheduleMeeting_CustomFieldResponses}[${customField.id.value}][${RAW_RESPONSE_CONTENT_KEY}]`"
                        :modelValue="savedValue.response ?? undefined"
                        :useBookingFormThemeCssVariables="true"
                        :checked="option === (savedValue.response ?? null)"
                    />
                </div>
            </template>
        </template>
        <template v-else>
            <UnexpectedError />
        </template>
    </FormControl>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'
    import RadioInput from '@/Shared/Component/Forms/RadioInput.vue'
    import {
        CustomFieldRadioSelectTypeEnum,
        RAW_RESPONSE_CONTENT_KEY,
        RAW_RESPONSE_CUSTOM_FIELD_ID_KEY,
        type CustomFieldResponseDTO,
        type CustomFieldSettingsRadioSelectType,
    } from '@/Shared/AutoGenerated/Main'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import UnexpectedError from '@/BookingForm/BookingForm/Component/CustomField/UnexpectedError.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
        savedValue: {
            type: Object as PropType<CustomFieldResponseDTO>,
            required: true,
        },
    })

    const localSettings: CustomFieldSettingsRadioSelectType =
        props.customField.settings
</script>
